<template>
  <div>
    <b-spinner
      v-if="fetching"
      variant="primary"
    />
    <ZoneServiceVersion
      v-else
      :is-new="false"
      :last-version="version"
      :service="version.service_class"
      :zones="zones"
    />
  </div>
</template>

<script>
import { reactive, ref } from '@vue/composition-api'
import { BSpinner } from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import ZoneServiceVersion from '../components/version-form/ZoneServiceVersion.vue'
import zonesStore from '@/views/zones/zoneStoreModule'
import store from '../store'

export default {
  components: {
    BSpinner,
    ZoneServiceVersion,
  },
  setup(_, ctx) {
    useRegisterStoreModule('zones', zonesStore)
    useRegisterStoreModule('versions', store)

    const { id } = ctx.root.$route.params
    const zones = reactive({})
    const version = ref()
    const fetchingZones = ref(false)
    const zonesNames = ref([])
    const fetchZones = async () => {
      try {
        fetchingZones.value = true
        const res = await ctx.root.$store.dispatch('zones/fetchZones')
        zonesNames.value = [...new Set(res.map(el => `${el.country}::${el.city}`))]
        zonesNames.value.forEach(name => {
          zones[name] = null
        })
      } catch (error) {
        console.log(error)
      } finally {
        fetchingZones.value = false
      }
    }

    const fetching = ref(false)
    const fetchVersion = async () => {
      fetching.value = true
      await fetchZones()
      const result = await ctx.root.$store.dispatch('versions/getVersion', {
        versionId: id,
      })
      version.value = result.data.data
      fetching.value = false
    }
    fetchVersion()

    return {
      zones,
      zonesNames,
      version,
      fetching,
    }
  },
}
</script>

 <style>

 </style>
